import Head from "next/head";
import { useTranslation } from "react-i18next";
import { useSyncExternalStore } from "react";
import { getNitoelEnv } from "lib/nitoelEnv";

type Props = {
  title?: string;
  primaryLang?: string;
};

const subscribeNothing = () => () => {};
const getServerEnvPrefix = () => "";
const getEnvPrefix = () => {
  try {
    const env = getNitoelEnv();
    if (env !== "prod" && env !== "unknown") {
      return `[${env}] `;
    }
  } catch (e) {
    console.warn("Failed to detect NitoelEnv in PageHead:", e);
  }
  return "";
};

const PageHead: React.FC<Props> = ({ title, primaryLang }) => {
  const { t, ready } = useTranslation("common");
  // SSR / hydration 時は空文字、クライアントでのみ環境名を付ける
  const envPrefix = useSyncExternalStore(subscribeNothing, getEnvPrefix, getServerEnvPrefix);

  const fallbackTitle = primaryLang === "ja" ? "ニトエル" : "nitoel";
  const serviceName = ready ? t("service_name") : fallbackTitle;

  return (
    <Head>
      {/* [環境名] 機能タイトル | ニトエル */}
      <title>{`${envPrefix}${title ? `${title} | ` : ""}${serviceName}`}</title>
    </Head>
  );
};

export default PageHead;
